export const API_URL = process.env.REACT_APP_BASE_URL as string;
export const SYSTEM_VERSION = process.env.REACT_APP_SYSTEM_VERSION as string;
export const CLIENT_KEY = process.env.REACT_APP_CLIENT_KEY as string;
